<template>
  <router-link
    v-if="challenge"
    to="/pos/challenge/current"
    data-test="challenge-home-block"
    class="px-6 py-4 rounded-2xl bg-primary-light border border-primary-lighter shadow-sm hover:shadow-md transition-shadow flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
  >
    <div>
      <p class="text-xs font-semibold uppercase tracking-widest text-primary-dark">
        🏆 {{ t("badge", { title: challenge.title }) }}
      </p>
      <p v-if="topTier" class="text-xl font-extrabold tracking-tight text-gray-900">{{ topRewardText }}</p>
    </div>
    <span
      class="inline-flex items-center gap-2 self-start sm:self-auto rounded-2xl bg-gray-900 px-4 py-2 text-sm font-semibold text-white whitespace-nowrap"
    >
      {{ t("see_details") }}
      <ArrowRightIcon class="h-4 w-4" />
    </span>
  </router-link>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions, mapState } from "vuex";
import { ArrowRightIcon } from "@heroicons/vue/solid";
import { sortTiers, tierReward } from "@/utils/challengeTiers";

// Teaser of the challenge running in the store, on the POS home: what there is to win, linking to the challenge
// follow-up for the details. Hidden when no challenge is running.
export default {
  components: { ArrowRightIcon },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    storeId: {
      type: [Number, String],
      default: null,
    },
  },

  computed: {
    ...mapState("challenge", { challenge: "activeChallenge" }),

    topTier() {
      const tiers = sortTiers(this.challenge.salesTargets || []);
      return tiers[tiers.length - 1] ?? null;
    },

    // A labelled reward (e.g. a trip) is the prize itself; an amount is the most there is to win
    topRewardText() {
      const key = this.topTier.label ? "top_reward_label" : "top_reward_amount";
      return this.t(key, { reward: tierReward(this.topTier) });
    },
  },

  watch: {
    storeId: {
      handler(storeId) {
        this.fetchActiveChallenge(storeId);
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("challenge", ["fetchActiveChallenge"]),
  },
};
</script>

<i18n src="./ChallengeHomeBlock.i18n.json"></i18n>
